import React from 'react';
import List from './list';
import Edit from './edit';
import './user.css';

export default function ServiceList({ match, ...rest }) {
	if (match.params.serviceId) {
		return <Edit u={match.params.serviceId} {...rest} />;
	}
	return <List {...rest} />;
}
